import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { useIsAdmin } from "./auth";
import { history } from "./router";
import PageLoader from "./../components/PageLoader";

// Higher-order component for requiring admin authentication
export const requireAdmin = (Component) => {
  return function RequireAdminHOC(props) {
    const auth = useAuth();
    const isAdmin = useIsAdmin();
    const [showError, setShowError] = useState(false);

    useEffect(() => {
      // If auth is still initializing, do nothing yet
      if (auth.user === null) {
        return;
      }

      // If not signed in, redirect to sign in page
      if (auth.user === false) {
        history.replace("/auth/signin");
        return;
      }

      // If signed in but not admin, show error and redirect home
      if (!isAdmin) {
        setShowError(true);
        // Hide error message after 3 seconds
        const timer = setTimeout(() => {
          setShowError(false);
          history.replace("/");
        }, 3000);
        return () => clearTimeout(timer);
      }
    }, [auth.user, isAdmin]);

    // Show loading indicator while auth is initializing
    if (auth.user === null) {
      return <PageLoader />;
    }

    // Show error message while redirecting non-admin users
    if (!isAdmin) {
      return (
        <div className="fixed top-4 right-4 bg-red-500 text-white px-6 py-3 rounded shadow-lg z-50">
          Access Denied: Admin privileges required
        </div>
      );
    }

    // Render admin component for admin user
    return <Component {...props} />;
  };
}; 